import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import AnalyticsProvider from './components/AnalyticsProvider';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsProvider>
        <App />
        <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'linear-gradient(145deg, rgba(20, 20, 25, 0.98) 0%, rgba(15, 15, 18, 0.98) 100%)',
            color: '#FFFFFF',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            padding: '16px 20px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.05)',
            backdropFilter: 'blur(20px)',
            maxWidth: '400px',
          },
          success: {
            style: {
              background: 'linear-gradient(145deg, rgba(16, 185, 129, 0.15) 0%, rgba(15, 15, 18, 0.98) 100%)',
              border: '1px solid rgba(16, 185, 129, 0.2)',
            },
            iconTheme: {
              primary: '#10B981',
              secondary: '#FFFFFF',
            },
          },
          error: {
            style: {
              background: 'linear-gradient(145deg, rgba(220, 70, 74, 0.15) 0%, rgba(15, 15, 18, 0.98) 100%)',
              border: '1px solid rgba(220, 70, 74, 0.2)',
            },
            iconTheme: {
              primary: '#dc464a',
              secondary: '#FFFFFF',
            },
          },
          loading: {
            style: {
              background: 'linear-gradient(145deg, rgba(42, 74, 91, 0.15) 0%, rgba(15, 15, 18, 0.98) 100%)',
              border: '1px solid rgba(42, 74, 91, 0.2)',
            },
            iconTheme: {
              primary: '#6c7e8d',
              secondary: '#FFFFFF',
            },
          },
        }}
      />
      </AnalyticsProvider>
    </BrowserRouter>
  </React.StrictMode>
);

